import React from 'react'
import ReactDOM from 'react-dom'
import App from './app'
import registerServiceWorker from './registerServiceWorker'
import {BrowserRouter as Router} from 'react-router-dom'
import 'bootstrap/dist/css/bootstrap-theme.min.css'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'react-tabs/style/react-tabs.css'
import 'react-bootstrap-table/dist/react-bootstrap-table.min.css'
import './index.scss'
import 'font-awesome/css/font-awesome.min.css'
import jQuery from 'jquery'
import 'bootstrap/js/dropdown'
import {Provider} from 'react-redux'
import createStore from './store'
import createAPI from './api'

global.jQuery = jQuery
registerServiceWorker()
const apis = createAPI()
const store = createStore({apis})

ReactDOM.render(
  <Provider store={store}>
    <Router><App/></Router>
  </Provider>,
  document.getElementById('root')
)



// WEBPACK FOOTER //
// ./src/index.js